export default "__VITE_ASSET__Cv9zCs0H__"